/**
 * ABP setting names behind Administration &gt; Settings &gt; Localization.
 *
 * All of them are registered with `isVisibleToClients: true` by the backend
 * `LocalizationSettingsProvider`, so they arrive with the application configuration and can be read
 * synchronously through `ConfigStateService.getSetting`.
 *
 * The four display formats are persisted as the **enum member name** (e.g. `DayMonthYear`), not as
 * the numeric value — see `LocalizationSettingsAppService.UpdateAsync`.
 */
export const LOCALIZATION_SETTING_KEYS = {
  dateFormat: 'Localization.DateFormat',
  timeFormat: 'Localization.TimeFormat',
  phoneNumberFormat: 'Localization.PhoneNumberFormat',
  numberFormat: 'Localization.NumberFormat',
  /** ABP's own definition, reused by the backend as the tenant language. */
  language: 'Abp.Localization.DefaultLanguage',
  /**
   * The tenant's default country calling code (digits, normally without `+`), shown on the same
   * screen. Defined by the backend `PhoneNumberSettingsProvider`, hence outside the `Localization.`
   * prefix; read it through `LocalizationDisplayService.defaultCountryCode`, which validates it.
   */
  defaultCountryCode: 'PhoneNumber.DefaultCountryCode',
} as const;
